"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Details = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const details_1 = require("@geome/react-components-next/lib/components/details");
const Details = ({ location }) => ((0, jsx_runtime_1.jsx)(details_1.Details, { sectionName: "details", configPath: "station_page.", location: location }));
exports.Details = Details;
